import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// Silent re-auth için global fetch wrapper'ı yükle (side-effect import)
import "@/services/api";
import { initCapacitor } from "@/native/capacitor-bootstrap";

// Native platform (iOS/Android) için deep link, push notification, status bar
// setup'ı. Web tarayıcıda no-op.
initCapacitor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
